<template>
    <div class="tablePage">
        <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
            :header-cell-style="headCellStyle" :height="tableHeight" @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="55" />

            <el-table-column prop="title" :label="$t('public.reason')" show-overflow-tooltip>
                <template #default="{row}">
                    <i v-icon:theme="['reasonConvert', row.type]"></i>
                    <span>{{row.title}}</span>
                </template>
                </el-table-column>
            <el-table-column prop="scopeName" v-if="$store.state.type === 3 || $store.state.type === 2" :label="$t('labelTitle.Range')" show-overflow-tooltip />

            <el-table-column prop="describe" :label="$t('public.table_desc')" show-overflow-tooltip />
            <el-table-column :label="$t('tableTitle.Operating')" width="120px" prop="name" align="center">
            <template #default="{ row }">
                <template v-if="row.type === 1">
                
                    <el-button
                        type="text"
                        icon="el-icon-edit-outline"
                        size="small"
                        :title="$t('buttonTitle.Edit')"
                        @click="handleCompile(row)"
                    ></el-button>
                    <el-button
                        @click="delsMonitor(row)"
                        :title="$t('buttonTitle.Delete')"
                        icon="el-icon-delete"
                        type="text"
                        size="small"
                    ></el-button>
                </template>
                <span v-else>--</span>
            </template>
        </el-table-column>

        </el-table>
    </div>
</template>

<script>
export default {
    props: ['tableData', 'loading'],
    computed: {
    },
    data() {
        return {
            tableHeight: "calc(100% - 60px)"
        }
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg)
        },
        handleCompile(row) {
            this.$emit('editRow', row)
        },
        delsMonitor(row){
            this.$emit('delRow', row)
        }
    }
}
</script>

<style lang="scss" scoped>
.tablePage {
    height: calc(100% - 60px);
}
</style>